import { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_email", res.data.email);
      navigate("/admin/dashboard");
    } catch (err) {
      setError("Credenziali non valide. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-6"
      style={{ backgroundColor: "#FAF9F6" }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-sm"
      >
        <div className="text-center mb-10">
          <h1
            className="text-3xl tracking-tighter text-[#1A1B1A] mb-2"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}
          >
            ETERNA <span className="font-light">Motion</span>
          </h1>
          <p
            className="text-xs uppercase tracking-[0.2em] text-[#757575]"
            style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 400 }}
          >
            Pannello Amministrazione
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label
              className="text-xs uppercase tracking-[0.15em] text-[#757575]"
              style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}
            >
              <Mail strokeWidth={1.25} size={14} className="inline mr-2" />
              Email
            </Label>
            <Input
              type="email"
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="rounded-none border-[#D8D4CC] bg-transparent focus:border-[#C4A462] focus:ring-0 h-12 text-sm"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
              placeholder="admin@eternamotion.com"
            />
          </div>

          <div className="space-y-2">
            <Label
              className="text-xs uppercase tracking-[0.15em] text-[#757575]"
              style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}
            >
              <Lock strokeWidth={1.25} size={14} className="inline mr-2" />
              Password
            </Label>
            <Input
              type="password"
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="rounded-none border-[#D8D4CC] bg-transparent focus:border-[#C4A462] focus:ring-0 h-12 text-sm"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
              placeholder="Password"
            />
          </div>

          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-600 text-center">{error}</p>
          )}

          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full btn-luxury disabled:opacity-50"
          >
            {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
